
import LogoWhite10 from "../../../Media/PNG/LogoWhite10.svg";
import LogoBlue from "../../../Media/PNG/LogoBlue.svg";
import Back from "./Back";
import GradientBlue from "../../../Components/InputFields/GradientBlue";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getRedirectFromNext } from "../../../helper/nextRedirect";
import { API_BASE_URL } from "../../../config/api";
import OtpCode from "../../../Components/InputFields/OtpCode";

export default function ContainerSignInPhoneOTP(isEmail = false) {
  const isDark =
    typeof document !== "undefined" &&
    document.documentElement.classList.contains("dark");
  const logoSrc = isDark ? LogoWhite10 : LogoBlue;
  const navigate = useNavigate();
  const { search } = useLocation();
  const nextParam = new URLSearchParams(search).get("next");
  const redirectFromNext = getRedirectFromNext(nextParam);
  const storedRedirect = localStorage.getItem("post_login_redirect");
  const redirectPath = redirectFromNext || storedRedirect;
  const hasRedirect = Boolean(redirectPath);
  const [inputNums, setInputNums] = useState(["", "", "", "", "", ""]);
  const [codeInvalid, setCodeInvalid] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitInFlightRef = useRef(false);
  useEffect(() => {
    if (inputNums.every((num) => num !== "")) {
      handleSignin();
    }
  }, [inputNums]);

  useEffect(() => {
    if (redirectFromNext) {
      localStorage.setItem("post_login_redirect", redirectFromNext);
    }
  }, [redirectFromNext]);

  const handleSignin = async (e) => {
    if (e) {
      e.preventDefault();
    }
    if (submitInFlightRef.current) {
      return;
    }
    const verificationCode = inputNums.join("");
    if (verificationCode.length < 6) {
      setCodeInvalid(true);
      return;
    }
    submitInFlightRef.current = true;
    setIsSubmitting(true);
    setCodeInvalid(false);
    const signinData = JSON.parse(localStorage.getItem("authCredentials"));
    try {
      const response = await fetch(
        `${API_BASE_URL}auth/trader/login/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: signinData.email,
            username: signinData.email,
            password: signinData.password,
            otp: verificationCode,
          }),
        },
      );

      const result = await response.json();

      if (!result.auth) {
        setCodeInvalid(true);
        return;
      }

      // Check if server responded with error status
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }
      localStorage.setItem("refresh", result.refresh);
      localStorage.setItem("access", result.access);
      localStorage.setItem("role", result.role);
      localStorage.setItem("email", result.email);
      localStorage.removeItem("authCredentials");
      if (hasRedirect) {
        localStorage.removeItem("post_login_redirect");
      }
      navigate(redirectPath || "/dashboard");
    } catch (error) {
      console.error("POST request failed:", error);
      return null; // or throw error again if you want
    } finally {
      submitInFlightRef.current = false;
      setIsSubmitting(false);
    }
  };
  return (
    <div className="w-full max-w-sm bg-zi-bg2-light dark:bg-zi-inputbg-dark/50 rounded-3xl p-5 gap-7 flex flex-col">
      <div className="flex flex-col gap-2 justify-center items-center">
        <div className="h-14">
          <img src={logoSrc} alt="لوگو" className="w-14" />
        </div>
        <p className="font-medium text-sm text-zi-text-light dark:text-zi-text-dark">
          کوژیتو فاند
        </p>
      </div>

      <div className="flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <h1 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
            کد یک‌بار مصرف را وارد کنید
          </h1>

          <Back />
        </div>

        <span className="text-xs font-light text-zi-text-light/50 dark:text-zi-text-dark/50">
          کدی که به شماره ۰۹۱۲۳۴۵۶۷۸۹ ارسال شده را وارد کنید.
        </span>
      </div>

      <div className="flex flex-col gap-4 items-end">
        <OtpCode
          values={inputNums}
          setValues={setInputNums}
          onValueChange={() => setCodeInvalid(false)}
          inputClassName="size-full aspect-square rounded-lg caret-zi-blue-light border border-zi-border-light dark:border-none bg-zi-bg2-light dark:bg-zi-inputbg-dark hocus-within:bg-zi-bg1-light text-center text-xl font-medium text-zi-text-light dark:text-zi-text-dark outline-none hocus-within:ring-1 hocus-within:ring-zi-border-light hocus-within:dark:ring-zi-border-dark [direction:ltr]"
        />

        <button
          type="button"
          className="text-zi-blue-light text-xs hocus:underline flex items-center gap-1"
        >
          <span>ارسال مجدد کد</span>
          <span>
            (<span>۶۰</span> ثانیه)
          </span>
        </button>
      </div>
      {codeInvalid && (
        <p className="text-amber-400 text-sm">کد وارد شده صحیح نمی‌باشد</p>
      )}

      <GradientBlue
        type="submit"
        value="ورود"
        isLoader={isSubmitting}
        onClick={handleSignin}
      />
    </div>
  );
}
